export default "__VITE_ASSET__7aa1bb77__"